module.exports = __webpack_public_path__ + "static/media/logo.954c2008.png";